// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';

export let DirectPortfolioSystemMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_PORTFOLIO_SYSTEM)

    this.PortfolioManagerLogin = null;       // PFixStringField FIELD_LOGIN = new PFixIntField(3); - логин Portfolio manager-a
    this.PortfolioSystemID = null;           // PFixIntField FIELD_PORTFOLIO_SYSTEM_ID = new PFixIntField(727); - идентификатор портфолио системы
    this.PortfolioSystemName = null;         // PFixStringField FIELD_NAME = new PFixIntField(22); - строковое название системы
    // this.StatusOut = null;                   // PFixIntField FIELD_STATUS = new PFixIntField(708);
}

DirectPortfolioSystemMessage.prototype = Object.create(DirectMessageBase.prototype)